import { useReveal } from "../../lib/hooks";

export function CTA() {
  const { ref } = useReveal<HTMLDivElement>();

  return (
    <section id="community" className="relative py-24 md:py-32 overflow-hidden">
      {/* Background atmosphere — a barely-visible Devanagari "om" on the left */}
      <span
        className="absolute font-deva pointer-events-none select-none"
        aria-hidden
        style={{
          fontSize: "clamp(20rem, 36vw, 36rem)",
          color: "var(--color-violet)",
          opacity: 0.07,
          left: "-3%",
          top: "50%",
          transform: "translateY(-50%)",
          lineHeight: 0.8,
          letterSpacing: "-0.05em",
          zIndex: 0,
        }}
      >
        ॐ
      </span>

      {/* Paramparā presence — static cutout on the right (desktop only).
          No parallax, no filters: scrolling stays buttery-smooth. */}
      <div
        aria-hidden
        className="hidden lg:block absolute pointer-events-none select-none"
        style={{
          top: "5%",
          right: "2%",
          width: "clamp(16rem, 24vw, 24rem)",
          zIndex: 0,
          contain: "strict",
          contentVisibility: "auto",
          containIntrinsicSize: "24rem 36rem",
        }}
      >
        <img
          src="/photos/pandit-cutout.png"
          alt=""
          className="w-full h-auto block"
          style={{ opacity: 0.55 }}
          loading="lazy"
          decoding="async"
        />
      </div>

      <div ref={ref} className="container-edit relative reveal" style={{ zIndex: 1 }}>
        <div className="max-w-4xl">
          <p className="eyebrow flex items-center gap-3 mb-10">
            <span className="inline-block w-8 h-px bg-[var(--color-violet)]" />
            <span>Begin</span>
          </p>
          <h2 className="font-display text-[clamp(3rem,8vw,7rem)] leading-[0.97] tracking-[-0.02em]">
            If any of this{" "}
            <span className="font-display-italic" style={{ color: "var(--color-violet)" }}>
              calls to you
            </span>
            .
          </h2>
          <hr className="rule-violet w-12 my-10" />
          <p className="text-[1.2rem] leading-[1.55] text-[var(--color-ink-soft)] max-w-[52ch]">
            Create a free account for course materials, recordings, and the
            calendar of upcoming events. Or sign in if you've been here before.
          </p>
          <div className="mt-12 flex flex-wrap items-center gap-x-8 gap-y-4">
            <a href="/register" className="btn-primary">
              <span>Create a free account</span>
              <span className="btn-arrow-icon" aria-hidden>
                →
              </span>
            </a>
            <a href="/login" className="btn-ghost">
              <span>I already have one</span>
              <span className="btn-arrow-icon" aria-hidden>
                →
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
